import { RequestContext } from '../../types/request-context';

export namespace Inspector {

    export type InspectorOperation = 'GetWeblabs' | 'CreateGeoToken' | 'ParseIdentityContext' | 'GetFieldOverrides';

    export interface Request {
        context: RequestContext;
        version?: number;
        operation: InspectorOperation;
        args?: string
    }
    export interface Response {
        weblabs?: {
            [name: string]: WeblabAssignment;
        }
        geoToken?: string,
        identityContextJSON?: string,
        fieldOverrides?: FieldOverride[]
    }

    export interface WeblabAssignment {
        treatment: string;
        overriding?: string;
    }

    export enum FieldOverrideType { IntegerType = 'IntegerType', NumberType = 'NumberType', StringType = 'StringType', BooleanType = 'BooleanType'}

    export interface FieldOverride {
        description?: string;
        displayText?: string;
        fieldType?: FieldOverrideType;
        parameterName: string;
        values?: string[];
    }
}
